<template>
  <div id="app">
    <router-view/>
    <van-number-keyboard safe-area-inset-bottom/>
  </div>
</template>
<script>
import { numberKeyboard } from 'vant'

export default {
  components: {
    [numberKeyboard.name]: numberKeyboard
  }
}
</script>
<style>
  html,
  body {
    width: 100vw;
    box-sizing: border-box;
  }

  body {
    font-size: 16px !important;
    background-color: #f8f8f8;
    -webkit-font-smoothing: antialiased;
  }

  #app {
    height: 100%;
  }
</style>
